import Axios from 'utils/axios'
import {convertJSON} from "utils/helper";

export default {
	namespaced: true,
	state: {
		data: null,
		list: [],
		page: 1,
		pageSize: 10,
		total: 0,
		condition: {}
	},
	mutations: {
		update(state, payload) {
			Object.assign(state, payload)
		}
	},
	actions: {
		fetch({ commit, state }, payload) {
			const promise = Axios.get('/admin/video/list', {
				params: {
					...state.condition,
					...payload,
					page: state.page,
					pageSize: state.pageSize
				}
			})
			promise.then(function (res) {
				commit('update', {
					list: res.list || [],
					total: res.total || 0
				})
			})
			return promise
		},
		fetchOne({commit, state}, {id}) {
			const promise = Axios.post('/admin/video/detail', {
				id
			})
			promise.then(function (res) {
				commit('update', {
					data: res
				})

				const tpl = res.content
				if (tpl.outputDesc.bgColor) {
					tpl.outputDesc.bgColor = tpl.outputDesc.bgColor.replace(/RGBA\((\d+,\d+,\d+,)(\d+)\)/, function () {
						return "rgba(" + arguments[ 1 ] + (+arguments[ 2 ] / 255) + ")"
					})
				}

				commit('update', {
					scaleRate: 500/tpl.outputDesc.height,
					designWidth: tpl.outputDesc.width,
					designHeight: tpl.outputDesc.height,
					outputDesc: tpl.outputDesc,
					actions: tpl.actions || [],
					elements: tpl.elements || [],
					resource: tpl.resource || {},
					slots: res.config||[]
				}, {
					root: true
				})
			})
			return promise
		},
		create({commit, dispatch, state}, payload) {
			return Axios.post('/admin/video/save', payload)
		},
		save({commit, dispatch, state}, payload) {
			dispatch('elm_unselect', null, {root: true})
			return Axios.post('/admin/video/save', {
				...payload,
				content: payload.content
			})
		},
		delete({commit, state}, param) {
			return Axios.post('/admin/video/delete', param)
		},
		saveAE({ commit, state, rootState }, { id, name, design_type}) {
			return Axios.post('/admin/video/ae/save', {
				id,
				name: name,
				ae_type:rootState.ae_type,
				ae_content: {
					...rootState.ae_tpl,
					userElements:rootState.elements
				},
				generate_video:1,
				design_type: design_type,
				config: rootState.slots||[]
			})
		},
		saveCurrent({ commit, state, rootState }, { id, name, design_type}) {
			let outputDesc = rootState.outputDesc || {}
			if (outputDesc.bgColor) {
				outputDesc.bgColor = outputDesc.bgColor.replace(/rgba\((\d+,\d+,\d+,)(\d+)\)/, function () {
					return "RGBA(" + arguments[ 1 ] + (+arguments[ 2 ] * 255) + ")"
				})
			}
			return Axios.post('/admin/video/save', {
				id,
				name: name,
				content: {
					...state.data&&state.data.content,
					outputDesc,
					actions: rootState.actions || [],
					elements: rootState.elements || [],
					resource: rootState.resource || {}
				},
				config: rootState.slots||[],
				generate_video: 1,
				design_type: design_type,
			})
		},
		previewVideo({commit, state, rootState}, {id}) {
			let outputDesc = rootState.outputDesc || {}
			if (outputDesc.bgColor) {
				outputDesc.bgColor = outputDesc.bgColor.replace(/rgba\((\d+,\d+,\d+,)(\d+)\)/, function () {
					return "RGBA(" + arguments[ 1 ] + (+arguments[ 2 ] * 255) + ")"
				})
			}

			return Axios.post('/admin/videoTemplate/previewVideo', {
				content: {
					...state.data&&state.data.content,
					outputDesc,
					actions: rootState.actions || [],
					elements: rootState.elements || [],
					resource: rootState.resource || {}
				}
			})
		},
		previewAE({commit, state, rootState}) {
			return Axios.post('/admin/videoTemplate/ae/preview', {
				ae_type:rootState.ae_type,
				ae_content: {
					...rootState.ae_tpl,
					userElements:rootState.elements
				}
			})
		},
		updateElements({commit, rootState}) {
			const ct = rootState.currentTime * 1000
			const actions = rootState.actions.filter(item => {
				return item.startTime <= ct && item.endTime >= ct
			})
			commit('update', {
				canvas: actions.map((item, index) => {
					const elm = rootState.elements.find(i => i.name === item.element)
					const pos = item.startPos.split(',')
					let data = {
						...elm,
						id: elm.name + '_' + item.name,
						rotate: 0,
						content: elm.value,
						x: +pos[ 0 ] * rootState.designWidth,
						y: +pos[ 1 ] * rootState.designHeight,
						width: (+pos[ 2 ] - +pos[ 0 ]) * rootState.designWidth,
						height: (+pos[ 3 ] - +pos[ 1 ]) * rootState.designHeight
					}
					if (elm.type === 'text') {
						let props = elm.textProp || {}
						data.style = {
							fontSize: props.fontSize || 48,
							color: props.color
						}
					} else if (elm.type === 'image') {
						data.content = rootState.resource[ elm.value ]
					}

					return data
				})
			}, {
				root: true
			})
		}
	}
}
